export const InvoiceTemplateIds = {
  STANDARD: 'STANDARD',
  ADVANCED: 'ADVANCED',
  EXPERT: 'EXPERT',
} as const;

export type InvoiceTemplateId = typeof InvoiceTemplateIds[keyof typeof InvoiceTemplateIds];
